<template>
  <div class="hm-home">
    <div class="card">
      <div class="panel flex item-center flex-between">
        <div>
          <el-button size="small" type="primary" @click="groupOperation('add')"
            >新建绩效等级</el-button
          >
        </div>
        <div class="form-wrapper flex flex-1 flex-wrap flex-end mb20">
          <el-input
            class="mr10"
            size="small"
            clearable
            placeholder="请输入绩效等级名称"
            v-model.trim="searchConditons.levelName"
            style="width: 150px"
          ></el-input>
          <el-button size="small" type="primary" @click="search"
            >查询</el-button
          >
        </div>
      </div>
      <div class="table mb20">
        <el-table stripe border :data="list" style="width: 100%">
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            width="50"
            label="序号"
            :index="index => index + (currentPage - 1) * pageSize + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="levelName"
            label="等级名称"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="已关联考核任务"
          >
            <template slot-scope="scope">
              <span v-for="(v, i) in scope.row.taskList" :key="i">
                {{ v.taskName }}
                <template v-if="i !== scope.row.taskList.length - 1"
                  >，</template
                >
              </span>
            </template>
          </el-table-column>
          <el-table-column header-align="center" align="center" label="操作">
            <template slot-scope="scope">
              <div class="flex flex-center item-center">
                <el-button
                  @click="groupOperation('edit', scope.row)"
                  class="blue"
                  size="small"
                  type="text"
                  >编辑</el-button
                >
                <div class="line"></div>
                <el-button
                  @click="relationTask(scope.row)"
                  class="blue"
                  size="small"
                  type="text"
                  >关联考核任务</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="text-center">
        <el-pagination
          background
          layout="total,sizes,  prev, pager, next, jumper"
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          :current-page="currentPage"
          ref="pagination"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      width="640px"
      :title="dialogTitle"
      :visible.sync="dialogVisible"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
      >
        <el-form-item label="绩效等级名称" prop="levelName">
          <el-input
            size="small"
            type="text"
            placeholder="请输入绩效等级名称"
            v-model="ruleForm.levelName"
            maxLength="10"
          ></el-input>
        </el-form-item>
        <el-form-item label="等级分区" prop="levelRange">
          <div class="level-area">
            <div class="area-header flex">
              <div class="front">等级名称</div>
              <div class="flex-1">分数区域范围</div>
            </div>
            <div class="area-body">
              <div
                class="flex item-center"
                v-for="(v, i) in ruleForm.area"
                :key="i"
              >
                <div class="front">
                  <el-input
                    type="text"
                    size="small"
                    maxlength="10"
                    style="width: 120px"
                    placeholder="输入等级名称"
                    v-model="v.pointName"
                  ></el-input>
                </div>
                <div class="flex-1 flex item-center">
                  <div style="width: 86px; height: 40px">
                    <el-input
                      v-show="i !== 0"
                      type="number"
                      size="small"
                      style="width: 86px"
                      v-model="v.lowerLimit"
                      placeholder="输入分值"
                      disabled
                    ></el-input>
                  </div>
                  <div class="symbol">
                    <span :class="{ transparent: i === 0 }"> ≤ </span>
                    <span style="margin: 0 10px">分数</span>
                    <span>&lt;</span>
                  </div>
                  <div>
                    <el-input
                      type="number"
                      size="small"
                      v-model="v.upperLimit"
                      :disabled="i < ruleForm.area.length - 1"
                      style="width: 86px"
                      placeholder="输入分值"
                      @input="changeMaxValue(v.upperLimit, i)"
                    ></el-input>
                  </div>
                  <div
                    v-if="i === ruleForm.area.length - 1"
                    class="add-wrapper"
                    @click="addRange(v)"
                  >
                    <span class="hmicon icon-hao pointer"></span>
                  </div>
                  <div
                    v-if="i > 0"
                    class="minus-wrapper"
                    @click="removeRange(i)"
                  >
                    <span class="hmicon icon-jianhao pointer"></span>
                  </div>
                </div>
              </div>
              <!-- 最大值 -->
              <div class="flex item-center">
                <div class="front">
                  <el-input
                    type="text"
                    size="small"
                    maxlength="10"
                    style="width: 120px"
                    placeholder="输入等级名称"
                    v-model="lastPointName"
                  ></el-input>
                </div>
                <div class="flex-1 flex item-center">
                  <div style="width: 86px; height: 40px">
                    <el-input
                      type="number"
                      size="small"
                      style="width: 86px"
                      v-model="lastLowerLimit"
                      placeholder="输入分值"
                      disabled
                    ></el-input>
                  </div>
                  <div class="symbol">
                    <span>≤</span>
                    <span style="margin: 0 10px">分数</span>
                  </div>
                  <div style="width: 86px; height: 40px"></div>
                </div>
              </div>
            </div>
          </div>
        </el-form-item>
        <div class="flex flex-center">
          <el-button
            v-if="operationType !== 'view'"
            @click="save"
            size="small"
            type="primary"
            >保存</el-button
          >
          <el-button @click="closeDialog" size="small">关闭</el-button>
        </div>
      </el-form>
    </el-dialog>
    <el-dialog
      title="关联考核任务"
      width="800px"
      :visible.sync="relationDialogVisible"
    >
      <div class="relation-container">
        <div class="label-row">
          <span class="label">绩效等级名称</span>
          <span>{{ currentRow.levelName }}</span>
        </div>
        <div class="label-row">
          <span class="label">关联考核任务</span>
        </div>
        <div class="table">
          <div class="panel">
            <div class="form-wrapper flex flex-end mb20">
              <el-input
                class="mr10"
                size="small"
                clearable
                placeholder="请输入考核任务名称"
                v-model.trim="taskName"
                style="width: 150px"
              ></el-input>
              <el-button
                class="ml0"
                size="small"
                type="primary"
                @click="queryTask"
                >查询</el-button
              >
            </div>
          </div>
          <div class="mb20">
            <el-table
              @selection-change="getChecked"
              stripe
              border
              ref="table"
              :data="taskList"
              id="table"
              row-key="id"
              size="small"
            >
              <el-table-column
                :reserve-selection="true"
                type="selection"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                type="index"
                label="序号"
                width="50"
                :index="
                  index => index + (taskCurrentPage - 1) * taskPageSize + 1
                "
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="taskName"
                label="考核任务名称"
              ></el-table-column>
            </el-table>
          </div>
          <div class="hm-pagination mb20">
            <el-pagination
              background
              :total="taskTotal"
              @current-change="taskPaging"
              @size-change="taskHandleSizeChange"
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="taskCurrentPage"
            ></el-pagination>
          </div>
        </div>
        <div class="flex flex-center">
          <el-button type="primary" size="small" @click="saveRelation"
            >保存</el-button
          >
          <el-button size="small" @click="relationDialogVisible = false"
            >关闭</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    const validLevelRange = (rule, val, callback) => {
      this.ruleForm.area.forEach(v => {
        if (!v.pointName) {
          return callback(new Error("请输入所有的等级名称"));
        }
        if (!v.upperLimit) {
          return callback(new Error("请输入所有的分值"));
        }
        if (v.lowerLimit && v.upperLimit && v.lowerLimit >= v.upperLimit) {
          return callback(new Error("请输入正确的分值"));
        }
      });
      if (!this.lastPointName) {
        return callback(new Error("请输入所有的等级名称"));
      }
      if (!this.lastLowerLimit) {
        return callback(new Error("请输入所有的分值"));
      }
      callback();
    };
    return {
      taskTotal: 0,
      taskList: [],
      taskCurrentPage: 1,
      taskPageSize: 10,
      selectedTaskList: [],
      relationDialogVisible: false,
      dialogVisible: false,
      currentRow: {},
      operationType: "",
      lastPointName: "",
      lastLowerLimit: "",
      ruleForm: {
        levelName: "",
        area: [
          {
            lowerLimit: "",
            upperLimit: "",
            pointName: ""
          }
        ]
      },
      dialogTitle: "",
      rules: {
        levelName: {
          required: true,
          message: "请输入绩效等级名称",
          trigger: "blur"
        },
        levelRange: {
          required: true,
          validator: validLevelRange
        }
      },
      taskName: "",
      searchConditons: {
        levelName: ""
      },
      total: 0,
      currentPage: 1,
      list: [],
      pageSize: 10,
      employeeList: []
    };
  },
  created() {},
  mounted() {
    this.queryList();
    this.queryEmployee();
  },
  watch: {},
  methods: {
    relationTask(row) {
      this.currentRow = row;
      this.relationDialogVisible = true;
      this.$nextTick(() => {
        if (row.taskList.length) {
          row.taskList.forEach(v => {
            if (v) {
              this.$refs.table.toggleRowSelection(v, true);
            }
          });
        } else {
          this.$refs.table.clearSelection();
        }
      });
      this.queryTask();
    },
    changeMaxValue(value, i) {
      if (i === this.ruleForm.area.length - 1) {
        this.lastLowerLimit = value;
        this.$forceUpdate();
        this.$refs.ruleForm.validate();
      }
    },
    addRange(v) {
      if (!v.upperLimit) {
        this.$message({
          type: "warning",
          message: "请先输入分值"
        });
        return;
      }
      this.lastLowerLimit = "";
      this.ruleForm.area.push({
        lowerLimit: v.upperLimit,
        upperLimit: ""
      });
    },
    removeRange(i) {
      this.ruleForm.area.splice(i, 1);
      this.lastLowerLimit = this.ruleForm.area[
        this.ruleForm.area.length - 1
      ].upperLimit;
    },
    drawDateChange() {
      this.ruleForm.planStartDate = "";
      this.ruleForm.planEndDate = "";
      this.ruleForm.timeDate = "";
    },
    resetRuleForm() {
      this.ruleForm.area = [
        {
          lowerLimit: "",
          upperLimit: "",
          pointName: ""
        }
      ];
      this.lastLowerLimit = "";
      this.lastPointName = "";
      this.ruleForm.levelName = "";
    },
    async queryList() {
      const params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize
      };
      Object.assign(params, this.searchConditons);
      const { result } = await this.$store.dispatch(
        "queryExamineLevelList",
        params
      );
      const { records, total } = result;
      this.list = records;
      this.total = total;
    },
    async stateOperation(row) {
      const status = row.status === "yes" ? "开启" : "关闭";
      const result = await this.$confirm(`${status}字段?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      if (result === "confirm") {
        this.queryList();
      }
    },
    async queryEmployee() {
      const { result } = await this.$store.dispatch("queryEmployee", {
        pageNo: 1,
        pageSize: 9999,
        loginType: "store",
        workingState: "yes"
      });
      this.employeeList = result.records;
    },
    groupOperation(type, row) {
      this.operationType = type;
      this.resetRuleForm();
      switch (type) {
        case "add":
          this.dialogVisible = true;
          this.dialogTitle = "添加绩效等级";
          setTimeout(() => {
            this.resetRuleForm();
          }, 0);
          break;
        case "edit":
          this.dialogVisible = true;
          this.resetRuleForm();
          this.currentRow = row;
          this.dialogTitle = "编辑绩效等级";
          this.queryLevelDetails(row);
          break;
        default:
          break;
      }
    },
    async queryLevelDetails(row) {
      const { result } = await this.$store.dispatch("queryLevelDetails", {
        id: row.id
      });
      const { levelName, levelPointInfoModelList } = result;
      this.ruleForm.levelName = levelName;
      const last = levelPointInfoModelList.length - 1;
      this.ruleForm.area = levelPointInfoModelList.slice(0, last);
      this.lastLowerLimit = levelPointInfoModelList[last].lowerLimit;
      this.lastPointName = levelPointInfoModelList[last].pointName;
    },
    async save() {
      const valid = await this.$refs.ruleForm.validate();
      if (valid) {
        let url = "addExamineLevel";
        const levelPointInfoModelList = JSON.parse(
          JSON.stringify(this.ruleForm.area)
        );
        levelPointInfoModelList.forEach(v => {
          if (!v.lowerLimit) {
            delete v.lowerLimit;
          }
        });
        levelPointInfoModelList.push({
          lowerLimit: this.lastLowerLimit,
          pointName: this.lastPointName
        });
        const params = {
          levelName: this.ruleForm.levelName,
          levelPointInfoModelList
        };
        if (this.operationType === "edit") {
          url = "editExamineLevel";
          Object.assign(params, {
            id: this.currentRow.id
          });
        }
        await this.$store.dispatch(url, params);
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.queryList();
        this.dialogVisible = false;
      }
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    taskPaging(page) {
      this.taskCurrentPage = page;
      this.queryTask();
    },
    taskHandleSizeChange(size) {
      this.taskCurrentPage = 1;
      this.pageSize = size;
      this.queryTask();
    },
    getChecked(list) {
      this.selectedTaskList = list;
    },
    async queryTask() {
      const params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize
      };
      Object.assign(params, this.searchConditons);
      const { result } = await this.$store.dispatch(
        "queryTargetTaskList",
        params
      );
      const { records, total } = result;
      this.taskList = records;
      this.taskTotal = total;
    },
    async saveRelation() {
      if (!this.selectedTaskList.length) {
        this.$message({
          type: "warning",
          message: "请先选择任务"
        });
        return;
      }
      await this.$store.dispatch("taskRelationLevel", {
        id: this.currentRow.id,
        taskIdList: this.selectedTaskList.map(v => {
          return {
            id: v.id
          };
        }),
        bindType: "level"
      });
      this.$message({
        type: "success",
        message: "操作成功"
      });
      this.queryList();
      this.relationDialogVisible = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.card {
  background: #fff;
  padding: 15px;
}
.table-panel {
  background: #fff;
  padding: 15px;
}

.table {
  .line {
    width: 1px;
    margin: 0 10px;
    height: 12px;
    background: #ddd;
  }
}

.details-dialog {
  .label {
    color: #000;
    font-weight: bold;
  }
}

.supervisedPerson-list {
  .person {
    margin-right: 50px;
    margin-bottom: 29px;
  }
  .store-name {
    color: #000;
    font-weight: bold;
  }
}

.level-area {
  .area-header {
    color: #000;
    font-weight: bold;
  }
  .front {
    width: 140px;
  }
  .symbol {
    margin: 0 10px;
    .transparent {
      opacity: 0;
    }
  }
}

.relation-container {
  .label-row {
    margin-bottom: 20px;
    .label {
      font-size: 14px;
      font-weight: bold;
      margin-right: 20px;
    }
  }
  .panel {
    margin-bottom: 20px;
  }
}
</style>
